import { createBrowserRouter } from "react-router-dom";
import Main from "../../layout/Main/Main";
import Apointment from "../../pages/Apointment/Apointment";
import Dashboard from "../../pages/Dashboard/Dashboard";
import Contactus from "../../pages/Home/Contactus/Contactus";
import Home from "../../pages/Home/Home/Home";
import Login from "../../pages/Login/Login";
import MainAppointment from "../../pages/MakeAppointment/MainAppointment/MainAppointment";
import Register from "../../pages/Register/Register";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import DashBoardLayout from "../../layout/Main/DashBoardLayout/DashBoardLayout";
import MyAppointment from "../../pages/Dashboard/MyAppointment/MyAppointment";
import AllUser from "../../pages/Dashboard/AllUser/AllUser";
import AdminRoute from "./AdminRoute/AdminRoute";
import AdDoctor from "../../pages/Dashboard/AdDoctor/AdDoctor";
import Mnagedoctor from "../../pages/Dashboard/Mnagedoctor/Mnagedoctor";
import Payment from "../../pages/Dashboard/Payment/Payment";
import DisplayError from "../../pages/Shared/DisplayError/DisplayError";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        errorElement:<DisplayError></DisplayError>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/mainappointment',
                element: <MainAppointment></MainAppointment>
            },
            {
                path: '/login',
                element: <Login></Login>
            },
            {
                path: '/register',
                element: <Register></Register>
            },
            {
                path: '/contactus',
                element: <Contactus></Contactus>
            }

        ]
    },
    {
        path: '/dashboard',
        element: <PrivateRoute>
           <DashBoardLayout>

           </DashBoardLayout>
        </PrivateRoute>,
        errorElement:<DisplayError></DisplayError>,
        children:[
            {
                path:'/dashboard',
                element:<MyAppointment></MyAppointment>
            },
            {
                path:'/dashboard/allusers',
                element:<AdminRoute><AllUser></AllUser></AdminRoute>
            },
            {
                path:'/dashboard/addoctor',
                element:<AdminRoute><AdDoctor></AdDoctor> </AdminRoute>
            },
            {
                path:'/dashboard/mnagedoctors',
                element:<AdminRoute><Mnagedoctor></Mnagedoctor> </AdminRoute>
            },
            {
                path:'/dashboard/payment/:id',
                element:<AdminRoute><Payment></Payment> </AdminRoute>,
                loader:({params}) =>fetch(`https://denticare-server-sumonhasan55.vercel.app/bookings/${params.id}`)
            },
        ]
    }

])
export default router;